import React from 'react';

import { useApartmentsSorting } from 'src/hooks/layouts/useApartmentsSorting';
import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { useGetFilterParams } from 'src/hooks';
import { Section } from '../Section';
import { useStyles } from './styles';
import { ISectionsList } from './types';
import { useSplitHouseToSections } from './useSplitHouseToSections';

export const SectionsList: React.FC<ISectionsList> = React.memo(({
  floorList,
  houseName,
  houseData,
  houseKeys,
}) => {
  const styles = useStyles({});
  const { sectionKey } = useSplitHouseToSections(houseData);
  const { selectedParams } = useGetFilterParams();
  const { sortApartments } = useApartmentsSorting();
  const getName = (section: string): string => {
    if (!selectedParams.length) {
      return `${houseKeys.length > 1 ? sectionKey.length > 1 ? `${houseName} /` : houseName : ''} ${sectionKey.length > 1 ? section : ''}`;
    }
    return `${houseKeys.length >= 1 ? sectionKey.length > 1 ? `${houseName} /` : houseName : ''} ${sectionKey.length > 1 ? section : ''}`;
  };
  return (
    <div id="sectionListWrapper" className={styles.sectionListWrapper}>
      <>
        {sectionKey.length && sectionKey
          .sort((a, b) => {
            const aIsNum = !Number.isNaN(a);
            const bIsNum = !Number.isNaN(b);

            if (aIsNum && bIsNum) {
              return Number(a) - Number(b);
            }

            if (aIsNum) return -1;
            if (bIsNum) return 1;

            return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
          })
          .map((section) => {
            return (
              <Section
                key={section}
                floorList={floorList}
                sectionName={getName(section)}
                sectionData={sortApartments<IFilterAllData>(houseData[section], ListOfKeysFilterAllData.placementNumeration)}
              />
            );
          })}
      </>
    </div>
  );
});
